import { OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Data } from '../../helpers';
import { DashboardService } from '../../dashboard';
import { ErrorHandlerService } from '../../services';
import { DASHBOARDENDPOINTS } from 'app/environment';
var MyAccountComponent = /** @class */ (function () {
    function MyAccountComponent(data, dashboardService, errorHandlerService, router) {
        this.data = data;
        this.dashboardService = dashboardService;
        this.errorHandlerService = errorHandlerService;
        this.router = router;
        this.paypalactivatehide = true;
        this.paypalactivate = false;
        this.paypalactivatenew = false;
        this.paypalupdate = false;
        this.msgTitle = "";
        this.msgContent = "";
        this.cPassword = "";
        this.changepass = false;
        this.addemail = false;
        this.update = false;
        this.loader = false;
        this.primaryEmailAddress = "";
        this.isAlternateEmailPrimary = false;
        this.isAlternateEmailPrimaryInResponse = false;
        this.isAlternateEmailIdPresent = false;
        this.accountdetails = { planBenefit: {} };
        this.accountdetails_original = { planBenefit: {} };
        this.address = { cityTO: { cityFullName: "" }, countryTO: {} };
        this.country = {};
        this.privacy = {};
        this.payPalSub = {};
        this.updatedetails = { userAddresses: [] };
        this.updateEmail = { alternateEmailId: "", isAlternateEmailPrimary: "FALSE" };
        this.updatePass = { userCredential: {} };
        this.popUp = false;
        this.payPalpopUp = false;
        this.basicPlan = {};
        this.basicId = "";
        this.basicPopup = false;
        this.basicPlanCheck = {};
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showErrorModalDialog = false;
        this.showLogOffModalDialog = false;
        this.showErrorMessages = [""];
        this.showErrorMessageTitle = "Error!";
        this.showErrorMessageWidthInPercentage = "20%";
        this.subscriptions = [];
        this.isSessionExpired = false;
        this.billingCycleEndDate = null;
        this.performLogout = false;
        this.deleteAccountConfirmationPopup = false;
        this.deleteAccountPasswordVerificationPopup = false;
        this.deleteAccountVerificationPassword = "";
        this.selectedCountryId = -1;
        this.countries = [];
        this.results = [];
        this.cityresults = [];
        this.isValidationError = false;
        this.showErrorPopupWidthInPercentage = "100%";
        this.isSignUp = true;
        this.pleaseWait = true;
        this.deleteAccShow = false;
        this.OTP = "";
        this.logoutConfirmationPopup = false;
    }
    MyAccountComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    MyAccountComponent.prototype.editinlineDisplay = function (edit) {
        if (edit) {
            return "inline-block";
        }
        else {
            return "none";
        }
    };
    MyAccountComponent.prototype.ngOnInit = function () {
        this.initFn();
    };
    MyAccountComponent.prototype.initFn = function () {
        var _this = this;
        var s1 = this.dashboardService.country()
            .subscribe(function (data) {
            _this.countries = data;
            console.log('this.countries', _this.countries);
            var s2 = _this.dashboardService.myAccountDetails().subscribe(function (data) {
                _this.accountdetails = data;
                _this.accountdetails_original = JSON.parse(JSON.stringify(data));
                if (data.isAlternateEmailPrimary) {
                    if (data.alternateEmailId) {
                        if (data.alternateEmailId.length > 0 && data.alternateEmailId !== " ") {
                            _this.isAlternateEmailIdPresent = true;
                        }
                        else {
                            _this.isAlternateEmailIdPresent = false;
                        }
                    }
                    else {
                        _this.isAlternateEmailIdPresent = false;
                    }
                }
                else {
                    _this.isAlternateEmailIdPresent = false;
                }
                if (data.isAlternateEmailPrimary == "TRUE") {
                    _this.primaryEmailAddress = data.alternateEmailId;
                    _this.isAlternateEmailPrimary = true;
                    _this.isAlternateEmailPrimaryInResponse = true;
                }
                else {
                    _this.primaryEmailAddress = data.emailId;
                    _this.isAlternateEmailPrimary = false;
                    _this.isAlternateEmailPrimaryInResponse = false;
                }
                _this.updateEmail.alternateEmailId = data.alternateEmailId;
                _this.updateEmail.isAlternateEmailPrimary = data.isAlternateEmailPrimary;
                if (_this.accountdetails.planBenefit) {
                    _this.billingCycleEndDate = _this.accountdetails.planBenefit.billingCycleEndDate;
                }
                //console.log("Seting this.isAlternateEmailPrimary to " + this.isAlternateEmailPrimary);
                console.log('user', data);
                _this.payPalSub.payPalId = data.payPalId;
                _this.address = (data.userAddresses == null) ? "" : data.userAddresses[0];
                _this.address.cityTO = (data.userAddresses == null) ? { cityFullName: "" } : (data.userAddresses[0].cityTO == null) ? { cityFullName: "" } : data.userAddresses[0].cityTO;
                _this.country = data.userAddresses[0].countryTO;
                _this.privacy = data.privacySettings;
                _this.selectedCountryId = _this.country.countryId;
            }, function (error) {
                _this.handleError(error);
            });
            _this.subscriptions.push(s2);
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s1);
        var s3 = this.dashboardService.upgradePlansall().subscribe(function (data) {
            data.allPlans.forEach(function (element) {
                if (element.membershipFeePerMonth == 0) {
                    _this.basicId = element.payPalMonthlyId;
                    _this.basicPlan = element;
                }
            });
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s3);
    };
    MyAccountComponent.prototype.closeErrorPopup = function () {
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showErrorMessageTitle = "";
        this.showErrorMessages = [];
        this.isValidationError = false;
        this.showErrorPopupWidthInPercentage = "100%";
        this.showErrorModalDialog = false;
        this.isSignUp = false;
        this.pleaseWait = false;
    };
    MyAccountComponent.prototype.BacisSelect = function () {
        var _this = this;
        //this.router.navigate(['dashboard/upgradeplan']);
        this.basicPlanCheck.paypalId = this.basicId.toString();
        var url = location.href;
        this.basicPlanCheck.cancelUrl = url.replace("upgradeplan", "upgrade?payment=cancel");
        this.basicPlanCheck.returnUrl = url.replace("upgradeplan", "upgrade?payment=success");
        this.basicPlanCheck.city = "malvern";
        this.basicPlanCheck.country = "US";
        this.basicPlanCheck.zip = "19355";
        this.basicPlanCheck.street = "56 Frazer";
        this.basicPlanCheck.state = "PA";
        //console.log(this.basicPlanCheck);
        var s3 = this.dashboardService.upgradePlanPaypal(this.basicPlanCheck).subscribe(function (data) {
            //console.log(data);
            if (data.success == true && data.launch_url == "NONE") {
                _this.initFn();
                _this.msgTitle = "Success!!";
                _this.msgContent = "Your request has been confirmed and your account will not be charged in subsequent billing cycle.";
                _this.popUp = true;
                _this.basicPopup = false;
            }
            else {
                _this.msgTitle = "Error!!";
                _this.msgContent = data.error;
                _this.popUp = true;
                _this.basicPopup = false;
            }
        }, function (error) {
            if (error.Uvsity_Errors) {
                _this.msgTitle = "Error";
                _this.msgContent = error.Uvsity_Errors;
                _this.popUp = true;
            }
            // this.loading = false;
        });
        this.subscriptions.push(s3);
    };
    MyAccountComponent.prototype.cancelMem = function () {
        //console.log(this.basicId);
        this.basicPopup = true;
    };
    MyAccountComponent.prototype.onChange = function (countryid) {
        this.selectedCountryId = countryid;
    };
    MyAccountComponent.prototype.saveDetails = function () {
        var _this = this;
        //console.log('The City name before Account data save==>' + this.address.cityTO.cityFullName);
        this.showSpinner = true;
        this.updatedetails.firstName = this.accountdetails.firstName;
        this.updatedetails.middleName = this.accountdetails.middleName;
        this.updatedetails.lastName = this.accountdetails.lastName;
        this.updatedetails.phoneMobile = this.accountdetails.phoneMobile;
        this.updatedetails.phoneWork = this.accountdetails.phoneWork;
        this.updatedetails.phoneHome = this.accountdetails.phoneHome;
        this.updatedetails.userAddresses[0] = this.address;
        this.updatedetails.userAddresses[0].countryTO = this.country;
        //this.updatedetails.userAddresses[0].cityTO.cityFullName = this.address.city;
        this.updatedetails.privacySettings = this.privacy;
        var s4 = this.dashboardService.myAccountDetailsUpdate(this.updatedetails).subscribe(function (data) {
            // once the data gets updates, the new data is the original data
            _this.accountdetails_original = JSON.parse(JSON.stringify(data));
            _this.accountdetails = data;
            _this.address = (data.userAddresses == null) ? "" : data.userAddresses[0];
            _this.country = (data.userAddresses == null) ? "" : data.userAddresses[0].countryTO;
            _this.privacy = data.privacySettings;
            //console.log('The City name after Account data save==>' + this.address.cityTO.cityFullName);
            if (data.isAlternateEmailPrimary) {
                if (data.alternateEmailId) {
                    if (data.alternateEmailId.length > 0 && data.alternateEmailId !== " ") {
                        _this.isAlternateEmailIdPresent = true;
                    }
                    else {
                        _this.isAlternateEmailIdPresent = false;
                    }
                }
                else {
                    _this.isAlternateEmailIdPresent = false;
                }
            }
            else {
                _this.isAlternateEmailIdPresent = false;
            }
            if (data.isAlternateEmailPrimary == "TRUE") {
                _this.primaryEmailAddress = data.alternateEmailId;
                _this.isAlternateEmailPrimary = true;
                _this.isAlternateEmailPrimaryInResponse = true;
            }
            else {
                _this.primaryEmailAddress = data.emailId;
                _this.isAlternateEmailPrimary = false;
                _this.isAlternateEmailPrimaryInResponse = false;
            }
            _this.showSpinner = false;
            _this.update = true;
            _this.createInfoAlert("Profile Updated Successfully.");
        }, function (error) {
            _this.showSpinner = false;
            _this.handleError(error);
        });
        this.subscriptions.push(s4);
    };
    MyAccountComponent.prototype.cancelDetails = function () {
        //console.log("Resetting items to orginal");
        this.accountdetails = JSON.parse(JSON.stringify(this.accountdetails_original));
        this.address = (this.accountdetails.userAddresses == null) ? "" : this.accountdetails.userAddresses[0];
        this.privacy = this.accountdetails.privacySettings;
        this.country = this.address.countryTO;
        this.selectedCountryId = this.country.countryId;
    };
    MyAccountComponent.prototype.updatePrimaryForCommunication = function (event) {
        if (event.target.checked) {
            this.updateEmail.isAlternateEmailPrimary = "TRUE";
        }
        else {
            this.updateEmail.isAlternateEmailPrimary = "FALSE";
        }
    };
    MyAccountComponent.prototype.addEmail = function () {
        var _this = this;
        this.showSpinner = true;
        var s5 = this.dashboardService.myAccountDetailsUpdateEmail(this.updateEmail).subscribe(function (data) {
            _this.showSpinner = false;
            _this.accountdetails = data;
            //this.address = data.userAddresses[0];
            //this.country = data.userAddresses[0].countryTO;
            //this.privacy = data.privacySettings;
            if (data.isAlternateEmailPrimary) {
                if (data.alternateEmailId) {
                    if (data.alternateEmailId.length > 0 && data.alternateEmailId !== " ") {
                        _this.isAlternateEmailIdPresent = true;
                    }
                    else {
                        _this.isAlternateEmailIdPresent = false;
                    }
                }
                else {
                    _this.isAlternateEmailIdPresent = false;
                }
            }
            else {
                _this.isAlternateEmailIdPresent = false;
            }
            _this.updateEmail.alternateEmailId = data.alternateEmailId;
            _this.updateEmail.isAlternateEmailPrimary = data.isAlternateEmailPrimary;
            _this.update = true;
            _this.addemail = false;
            _this.isAlternateEmailPrimary = (data.isAlternateEmailPrimary == "TRUE");
            _this.isAlternateEmailPrimaryInResponse = (data.isAlternateEmailPrimary == "TRUE");
            _this.createInfoAlert("Primary Communication Email Address Updated Successfully.");
            //console.log("Seting this.isAlternateEmailPrimary to " + this.isAlternateEmailPrimary);
        }, function (error) {
            _this.showSpinner = false;
            _this.handleError(error);
        });
        this.subscriptions.push(s5);
    };
    MyAccountComponent.prototype.updatePassword = function () {
        var _this = this;
        // If the New Password is blank, throw an error.
        if (!this.updatePass.userCredential.plainTextPassword) {
            this.createInfoAlert('The new password is empty. Please provide a non-empty value');
            return false;
        }
        else if (this.updatePass.userCredential.plainTextPassword.trim().length == 0) {
            this.createInfoAlert('The new password is empty. Please provide a non-empty value');
            return false;
        }
        if (this.updatePass.userCredential.plainTextPassword == this.cPassword) {
            this.showSpinner = true;
            var s6 = this.dashboardService.myAccountDetailsUpdatePass(this.updatePass).subscribe(function (data) {
                _this.showSpinner = false;
                _this.createInfoAlert("Password Changed Successfully.");
                _this.changepass = false;
            }, function (error) {
                _this.showSpinner = false;
                _this.handleError(error);
            });
            this.subscriptions.push(s6);
        }
        else {
            this.createInfoAlert('The new password does not match with the value you entered to confirm it. Please ensure that the "New Password" and "Confirm Password" values are same.');
        }
    };
    MyAccountComponent.prototype.paypalSumbit = function (type) {
        var _this = this;
        if (type == 'new') {
            this.showSpinner = true;
            var s7 = this.dashboardService.myAccountPaypal(this.payPalSub).subscribe(function (data) {
                _this.showSpinner = false;
                _this.accountdetails = data;
                _this.address = (data.userAddresses == null) ? "" : data.userAddresses[0];
                _this.country = (data.userAddresses == null) ? "" : data.userAddresses[0].countryTO;
                _this.privacy = data.privacySettings;
                _this.update = true;
                _this.createInfoAlert("Paypal Id change inititated. We have sent you an email. Please click on the link in the email to activate the new Paypal Id.");
                _this.paypalactivatehide = true;
                _this.paypalactivate = false;
            }, function (error) {
                _this.showSpinner = false;
                _this.handleError(error);
            });
            this.subscriptions.push(s7);
        }
        else if (type == 'update') {
            this.showSpinner = true;
            var s8 = this.dashboardService.myAccountPaypalUpdate(this.payPalSub).subscribe(function (data) {
                _this.showSpinner = false;
                _this.accountdetails = data;
                _this.address = (data.userAddresses == null) ? "" : data.userAddresses[0];
                _this.country = (data.userAddresses == null) ? "" : data.userAddresses[0].countryTO;
                _this.privacy = data.privacySettings;
                _this.update = true;
                _this.createInfoAlert("Paypal Id change inititated. We have sent you an email. Please click on the link in the email to activate the new Paypal Id.");
                _this.paypalactivatehide = true;
                _this.paypalactivate = false;
            }, function (error) {
                _this.showSpinner = false;
                _this.handleError(error);
            });
            this.subscriptions.push(s8);
        }
    };
    MyAccountComponent.prototype.paypalUpdateSumbit = function () {
    };
    MyAccountComponent.prototype.paypalDactivate = function () {
        var _this = this;
        this.showSpinner = true;
        var s9 = this.dashboardService.myAccountPaypalDeactivate().subscribe(function (data) {
            _this.showSpinner = false;
            _this.accountdetails = data;
            _this.address = (data.userAddresses == null) ? "" : data.userAddresses[0];
            _this.country = (data.userAddresses == null) ? "" : data.userAddresses[0].countryTO;
            _this.privacy = data.privacySettings;
            _this.update = true;
            _this.createInfoAlert("Paypal Deactivated Successfully.");
            _this.paypalactivatehide = true;
            _this.paypalactivate = false;
            _this.paypalactivatenew = false;
            _this.paypalupdate = false;
            _this.payPalpopUp = false;
        }, function (error) {
            _this.showSpinner = false;
            _this.handleError(error);
        });
        this.subscriptions.push(s9);
    };
    MyAccountComponent.prototype.confirmDeletionOfAccount = function () {
        this.deleteAccountConfirmationPopup = true;
    };
    MyAccountComponent.prototype.submitLogoutSuccess = function () {
        this.logoutConfirmationPopup = false;
        this.logout();
    };
    MyAccountComponent.prototype.submitOTP = function () {
        var _this = this;
        var d10 = this.dashboardService.deleteAccount(this.OTP).subscribe(function (data) {
            _this.showSpinner = false;
            _this.logoutConfirmationPopup = true;
            _this.performLogout = true;
            _this.deleteAccShow = false;
        }, function (error) {
            _this.showSpinner = false;
            _this.OTP = "";
            _this.handleError(error);
            _this.deleteAccShow = false;
        });
        this.subscriptions.push(d10);
    };
    MyAccountComponent.prototype.deleteAccClose = function () {
        this.deleteAccShow = false;
    };
    MyAccountComponent.prototype.verifyPasswordForAccountDeletion = function () {
        this.deleteAccountConfirmationPopup = false;
        this.showSpinner = true;
        this.showOnlyOverlay = true;
        this.showErrorMessageTitle = 'Info!!';
        this.showErrorMessages.push("Please wait... Sending OTP...");
        this.isValidationError = false;
        this.showErrorPopupWidthInPercentage = "100%";
        this.showErrorModalDialog = true;
        this.isSignUp = true;
        this.pleaseWait = true;
        var that = this;
        var apiurl = process.env.API_URL;
        setTimeout(function () {
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function () {
                if (this.readyState == 4 && this.status == 200) {
                    that.closeErrorPopup();
                    //delAcForm.resetForm();
                    that.deleteAccShow = true;
                }
                else {
                    that.closeErrorPopup();
                    //delAcForm.resetForm();
                    that.showSpinner = false;
                    that.handleError(this.responseText);
                }
            };
            xhttp.open("POST", apiurl + DASHBOARDENDPOINTS.deleteAccountOTP, true);
            xhttp.setRequestHeader("Content-type", "application/json");
            var currentUser = localStorage.getItem('authorization');
            if (currentUser) {
                xhttp.setRequestHeader("Authorization", currentUser);
            }
            xhttp.send("{}");
        }, 1000);
        //this.deleteAccountPasswordVerificationPopup = true;
    };
    MyAccountComponent.prototype.deleteAccount = function (delAcForm) {
        // let d10 = this.dashboardService.deleteAccountOTP().subscribe(
        //   data => {
        //     alert("test");
        //     // this.closeErrorPopup();
        //     // this.deleteAccShow = true;
        //   },
        //   error => {
        //     this.showSpinner = false;
        //     this.handleError(error);
        //   }
        // );
        // this.subscriptions.push(d10);
        // this.showSpinner = true;
        // this.deleteAccountConfirmationPopup = false;
        // this.deleteAccountPasswordVerificationPopup = false;
        // let s10 = this.dashboardService.deleteAccount(this.deleteAccountVerificationPassword).subscribe(
        //   data => {
        //     this.createInfoAlert("Account Deleted Successfully. You will now be logged off.");
        //     this.performLogout = true;
        //     this.showSpinner = false;
        //   },
        //   error => {
        //     this.showSpinner = false;
        //     delAcForm.resetForm();
        //     this.deleteAccountVerificationPassword = '';
        //     this.handleError(error);
        //   }
        // );
        // this.subscriptions.push(s10);
    };
    MyAccountComponent.prototype.closeMessagePopup = function () {
        this.popUp = false;
        if (this.performLogout == true) {
            this.performLogout = false;
            this.logout();
        }
    };
    MyAccountComponent.prototype.googleLogout = function () {
        var _this = this;
        gapi.load('auth2', function () {
            _this.auth2 = gapi.auth2.getAuthInstance();
            _this.auth2.signOut().then(function () {
                console.log("User signed out");
            });
            _this.auth2.disconnect();
            //this.attachSignout(document.getElementById('googleBtn2'));
        });
    };
    // Glogout() {
    //   this.socialAuthService.logout().subscribe(
    //     (data) => { console.log(data) }
    //   )
    // }
    MyAccountComponent.prototype.logout = function () {
        var _this = this;
        console.log('Logging Out');
        console.log("The Auth Header in localstorage in dashbord component==>" + localStorage.getItem('authorization'));
        var s11 = this.dashboardService.logOff().subscribe(function (data) {
            _this.googleLogout();
        }, function (error) {
            console.log("Error in calling the Logoff Service");
            console.log(error);
        });
        this.subscriptions.push(s11);
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showLogOffModalDialog = false;
        console.log("Removing the Authorization JWT token from LocalStorage");
        localStorage.removeItem('authorization');
        console.log("Navigating to Login page");
        this.router.navigate(['/login', 'true']);
    };
    // logout() {
    //   //console.log('Logging Out');
    //   //console.log("The Auth Header in localstorage in dashbord component==>"+localStorage.getItem('authorization'));
    //   let s11 = this.dashboardService.logOff().subscribe(
    //     data => {
    //     },
    //     error => {
    //       //console.log("Error in calling the Logoff Service");
    //       //console.log(error);
    //     }
    //   );
    //   this.subscriptions.push(s11);
    //   this.showSpinner = false;
    //   this.showOnlyOverlay = false;
    //   this.showLogOffModalDialog = false;
    //   //console.log("Removing the Authorization JWT token from LocalStorage");
    //   localStorage.removeItem('authorization');
    //   //console.log("Navigating to Login page");
    //   this.router.navigate(['/login']);
    // }
    MyAccountComponent.prototype.createInfoAlert = function (alert) {
        var infoAlert = {
            isInfo: true,
            infoMessage: alert,
            url: "not required"
        };
        this.handleError(infoAlert);
    };
    MyAccountComponent.prototype.handleError = function (error) {
        //console.log("The error inside the Error Handler==>" + error);
        var url = error.url;
        //console.log("The URL of the error==>"+error.url);
        if (url == undefined) {
            return;
        }
        //console.log("Throwing the error now. Shall call the errorHandlerService throwError method");
        this.errorHandlerService.throwError(error);
    };
    MyAccountComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (element) {
            element.unsubscribe();
        });
    };
    return MyAccountComponent;
}());
export { MyAccountComponent };
//# sourceMappingURL=myAccount.component.js.map